import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Auth from './Auth/Auth';
import { SettingsProvider } from './state/settings';
import './style'

ReactDOM.render(
  <React.StrictMode>
    <SettingsProvider>
      <BrowserRouter>
        <Auth>
          <App />
        </Auth>
      </BrowserRouter>
    </SettingsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
